<template>
    <div class="d-flex align-items-center justify-content-between">
      <div class="title">
        <img :src="image" class="page-icon" />
        <span>{{ name }}</span>
      </div>

      <b-input-group class="search-input" v-if="search">
        <b-form-input v-model="searchWord"></b-form-input>
         <template v-slot:append>
           <img src="../assets/img/search-icon.png" class="input-icon" @click="filter()">
        </template>
      </b-input-group>
    </div>
</template>

<script>
export default {
  name: 'PageName',
  props: {
    image: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    search: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      searchWord: ''
    }
  },
  methods: {
    filter () {
      this.$emit('filter', this.searchWord)
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  height: 80px;
  font-size: 36px;
  color: #222222;
  line-height: 40px;

  span {
    position: relative;
    left: -45px;
    top: 20px;
  }

  .page-icon {
    height: 80px;
    width: 80px;
  }
}

.search-input {
  width: 280px;

  input {
    border-radius: 0;
    height: 32px;
  }

  .input-icon {
    position: absolute;
    width: 18px;
    height: 18px;
    right: 12px;
    top: 6px;
    z-index: 10;
  }
}

@media (max-width: 500px) {
  .page-icon {
    display: none
  }

  .title {
    height: auto;
    font-size: 16px;
    margin-left: 20px;

    span {
      position: static;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageName.vue